import React from 'react';
import { string } from 'prop-types';
import { DateUtil } from '../../../utils/date-util';

const LastSavedDate = ({ value }) => {
   return (
      <div>
         {DateUtil.formatDate(
            value,
            DateUtil.DATE_FORMATS.DD_MMM_YY_TIME
         ).toUpperCase()}
      </div>
   );
};
LastSavedDate.propTypes = {
   value: string,
};
export default LastSavedDate;
